import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@shared/authentication';
import {
  StateLoaderComponent,
  StateLoaderTypes
} from '@shared/components/state-loader/state-loader.component';
import { asapScheduler, delay, take, withLatestFrom } from 'rxjs';

@Component({
  selector: 'app-callback',
  template: '<app-state-loader [type]="StateLoaderTypes.Loading"></app-state-loader>',
  imports: [StateLoaderComponent]
})
export class CallbackComponent implements OnInit {
  readonly StateLoaderTypes = StateLoaderTypes;

  private readonly authService = inject(AuthenticationService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.authService.isAuthenticated$
      .pipe(delay(3000), withLatestFrom(this.authService.redirectTarget$), take(1))
      .subscribe({
        next: ([authenticated, redirectTarget]: [boolean, string | null]) => {
          if (authenticated) {
            asapScheduler.schedule(() => this.router.navigateByUrl(redirectTarget ?? '/elements').then());
          } else {
            asapScheduler.schedule(() => this.router.navigate(['error']).then());
          }
        }
      });
  }
}
